(function ($) {
    'use strict';
    /**
     * плагин масштабирвоания текста
     * */
    $.fn.customSearch = function () {
        var $self = $(this);
        $self.addClass('custom-search');
        var $form = $self.find('form');
        var $select = $self.find('select');
        var $optionSelect = $select.find('option');
        var $searchList;
        var $searchInput;
        var $dropDown;
        var searchTimeOut;
        var toggleOpenTimeOut;
        var tagsValues = [];

        var OPEN_CLASS = 'open';
        var SELECTED_CLASS = 'selected';
        var SELF_HAS_SELECTED_CLASS = 'has-selected';

        /**
         * скрываем селект дефолтный
         */
        var hiddenAllSelect = function () {
            $select.addClass('hidden');
        };

        /**
         * создаем div
         * @param divClass
         * @param divText
         * @returns {string}
         */
        var createDiv = function (divClass, divText) {
            var text = divText ? divText : '';
            return '<div class="' + divClass + '">' + text + '</div>';
        };

        var createLabel = function (divClass, divText) {
            var text = divText ? divText : '';
            return '<label class="' + divClass + '">' + text + '</label>';
        };
        /**
         * создаем option
         * @param value
         * @returns {string}
         */
        var createOptionForSelect = function (value) {
            return '<option value="' + value + '"></option>';
        };

        /**
         * заполняем в селект значения выбранных тегов
         */
        var addValueFindElement = function () {
            $select.val(tagsValues);
        };

        /**
         * открытие закрытие дропдауна
         */
        var toggleDropDown = function () {
            if (toggleOpenTimeOut) {
                clearTimeout(toggleOpenTimeOut);
            }
            toggleOpenTimeOut = window.setTimeout(function () {
                $self.toggleClass(OPEN_CLASS);
            },0);
        };

        var toggleClassHasSelectedItems = function () {
            if (tagsValues.length > 0) {
                $self.addClass(SELF_HAS_SELECTED_CLASS);
                var inputValue = $searchInput.val();
                if (inputValue.length < 2) {
                    $searchInput.css({width: '25px'});
                }
            } else {
                $self.removeClass(SELF_HAS_SELECTED_CLASS);
                $searchInput.css({width: 'auto'});
            }
        };

        /**
         * вешаем на уже выбранные элементы в дропдауне класс, что они выбраны
         */
        var addSelectedClassInDropDownItems = function () {
            var $optionDropDown = $dropDown.find('.js-custom-search-dropdown-item');
            $optionDropDown.each(function (index, item) {
                var findSelectedItemInList = tagsValues.find(function (findItem) {
                    return findItem.toString() === $(item).data('value').toString();
                });
                if (findSelectedItemInList) {
                    $(item).addClass(SELECTED_CLASS);
                }
            });
        };

        /**
         * очищаем класс выбранного элемента
         */
        var clearSelectedClassInDropDown = function () {
            var $optionDropDown = $dropDown.find('.js-custom-search-dropdown-item');
            $optionDropDown.removeClass(SELECTED_CLASS);
        };

        /**
         * удаляем выбранный тэг
         * @param element
         */
        var removeSelectedTag = function (element) {
            var $tag = $(element).parent('.js-custom-search-selected-tag');
            var value = $tag.data('value');
            var indexValue = tagsValues.findIndex(function (item) {
                return item.toString() === value.toString();
            });
            if (indexValue !== -1) {
                tagsValues.splice(indexValue, 1);
                $tag.remove();
                addValueFindElement();
                clearSelectedClassInDropDown();
                addSelectedClassInDropDownItems();
                toggleClassHasSelectedItems();
            }
        };

        /**
         * создаем тег для добавления в список выбранных
         * @param color
         * @param value
         * @param text
         * @returns {*|jQuery|HTMLElement}
         */
        var createTagItem = function (color, value, text) {
            var deleteButton = createDiv('custom-search__selected-tag--delete js-custom-search-selected-tag-delete');
            var textSpan = '<span>' + text + '</span>';
            var addInTag = textSpan + deleteButton;
            var tagItem = createDiv('custom-search__selected-tag js-custom-search-selected-tag', addInTag);
            var $tagItem = $(tagItem);
            $tagItem.css({'background-color': color});
            $tagItem.attr('data-value', value);
            $tagItem.find('.js-custom-search-selected-tag-delete').on('click', function () {
                removeSelectedTag($(this));
            });
            return $tagItem;
        };

        /**
         * вешаем обработчики на элеенты в дропдауне
         */
        var addEventListenerInDropDownItem = function () {
            $('.js-custom-search-dropdown-item').on('click' ,function () {
                var value = $(this).data('value');
                var findIndex = tagsValues.findIndex(function (element) {
                    return element === value;
                });
                if (findIndex === -1) {
                    var $selectedItem = $(createTagItem($(this).data('color'), value, $(this).text()));
                    $searchList.append($selectedItem);
                    tagsValues.push(value);
                    var option = createOptionForSelect(value);
                    $select.append($(option));
                    toggleDropDown();
                    clearSelectedClassInDropDown();
                    addSelectedClassInDropDownItems();
                    toggleClassHasSelectedItems();
                    $searchInput.val('');
                }
                addValueFindElement();
            });
        };

        /**
         * создаем элемент для dropdown
         * @param fullName
         * @param color
         * @param value
         * @param text
         * @returns {*|jQuery|HTMLElement}
         */
        var createDropDownItem = function (fullName, color, value, text) {
            var dropDownItem = createDiv('custom-search__dropdown-item js-custom-search-dropdown-item');
            var $dropDownItem = $(dropDownItem);
            $dropDownItem.attr('data-full-name', fullName);
            $dropDownItem.attr('data-color', color);
            $dropDownItem.attr('data-value', value);
            $dropDownItem.text(text);
            return $dropDownItem;
        };

        /**
         * создаем дроп даун
         * @returns {*|jQuery|HTMLElement}
         */
        var createDropDown = function () {
            var dropDownShell = createDiv('custom-search__dropdown-shell');
            var dropDownWrapper = createDiv('custom-search__dropdown js-custom-search-dropdown');
            var $dropDownWrapper = $(dropDownWrapper);
            var $dropDownShell = $(dropDownShell);
            $dropDownShell.append($dropDownWrapper);
            $optionSelect.each(function (index, item) {
                var $dropDownItem = createDropDownItem($(item).data('full-name'), $(item).data('color'), $(item).attr('value'), $(item).text());
                $dropDownWrapper.append($dropDownItem);
            });
            return $dropDownShell;
        };

        /**
         * получение результата с задержкой
         * @param value
         */
        var findResultWithDebounce = function (value) {
            var $emptyItem = $('.js-custom-search-empty');
            if (searchTimeOut) {
                clearTimeout(searchTimeOut);
            }
            searchTimeOut = window.setTimeout(function () {
                $.ajax({
                    type    : 'get',
                    url     : '/site/load-tags',
                    dataType: 'json',
                    data    : {
                        'str'    : value,
                        'exclude': ''
                    },
                    success : function(data) {
                        $dropDown.empty();
                        if (data.length) {
                            $emptyItem.removeClass('active');
                            data.forEach(function (item) {
                                var $dropDownItem = createDropDownItem(item.label, item.color, item.id, item.name);
                                $dropDown.append($dropDownItem);
                                $self.addClass(OPEN_CLASS);
                            });
                            addEventListenerInDropDownItem();
                            clearSelectedClassInDropDown();
                            addSelectedClassInDropDownItems();
                        } else {
                            $emptyItem.addClass('active');
                            $self.removeClass(OPEN_CLASS);
                        }
                    }
                });
            }, 500);
        };

        /**
         * вешаем обработчик на инпут поиска
         */
        var addEventListenerSearchInput = function () {
            $searchInput.on('input', function () {
                var inputValue = $searchInput.val();
                findResultWithDebounce(inputValue);
                if ($self.hasClass(SELF_HAS_SELECTED_CLASS)) {
                    $searchInput.css({width: (inputValue.length * 10 + 5 + 'px')});
                }
            });
        };

        /**
         * пушим тэг как выбранный
         */
        var pushSelectedItemInList = function () {
            var $selectedOptions = $select.find('option:selected');
            $selectedOptions.each(function (index, selectedItem) {
                var value = $(selectedItem).attr('value');
                var $tagItem = createTagItem($(selectedItem).attr('data-color'), value, $(selectedItem).text());
                $searchList.append($tagItem);
                tagsValues.push(value);
            });
            addSelectedClassInDropDownItems();
            toggleClassHasSelectedItems();
        };

        /**
         * создаем кастомный селект
         */
        var createFindBLock = function () {
            var searchInput = "<input type='text' value='' placeholder='Поиск' class='custom-search__find-input js-custom-search-find-input'>";
            var resultWrapper = createDiv('custom-search__find-list js-custom-search-find-list');
            var appendBlock = resultWrapper + searchInput;
            var searchWrapper = createLabel('custom-search__find js-custom-search-find', appendBlock);
            var $dropDownWrapper = $(createDropDown());
            var emptyBlock = createDiv('custom-search__empty js-custom-search-empty', 'Совпадений нет');
            $form.append(searchWrapper);
            $form.append($dropDownWrapper);
            $form.append($(emptyBlock));
            $searchList = $('.js-custom-search-find-list');
            $searchInput = $('.js-custom-search-find-input');
            $dropDown = $('.js-custom-search-dropdown');
            addEventListenerInDropDownItem();
            addEventListenerSearchInput();
            pushSelectedItemInList();
            $(document).on('click', function (event) {
                if ($(event.target).closest('.js-custom-search') && $(event.target).closest('.js-custom-search').length > 0) {
                    return;
                }
                $self.removeClass(OPEN_CLASS);
            });
        };

        /**
         * инициализация плагина
         * */
        var init = function () {
            createFindBLock();
            hiddenAllSelect();
            $('.js-custom-search-find').on('click', toggleDropDown);
        };
        init();
        return this;
    };
    $('.js-custom-search').each(function () {
        $(this).data('customSearch', $(this).customSearch());
    });
})(jQuery);
